import { Grid } from '@livecontrol/core-ui';
import type { HTMLAttributes, ReactElement } from 'react';
import Nav from 'react-bootstrap/Nav';
import styled from 'styled-components';

export enum Tab {
  OperatorNotes = 'operator-notes'
}

type Props = HTMLAttributes<HTMLElement> & {
  tab: Tab;
  onSelect: (key?: string | null | undefined) => void;
};

const StyledNav = styled(Nav)`
  padding-bottom: 1px;
  border-bottom: 1px solid var(--white35);
`;

export const Tabber = ({ className, onSelect, tab }: Props): ReactElement => (
  <StyledNav className={className} variant='tabs' activeKey={tab} onSelect={onSelect}>
    <Grid gridTemplateColumns='1fr min-content' className='w-100'>
      <div className='d-flex flex-wrap row-gap-12px'>
        <Nav.Link key={Tab.OperatorNotes} eventKey={Tab.OperatorNotes}>
          Operator Notes
        </Nav.Link>
      </div>
    </Grid>
  </StyledNav>
);
